<div class="row do-not-print">
  <div class="col-md-2 col-12 odp-float-right-left">
    <div class="sideMenu" *ngIf="openedSideBar" [@slideInOut]>
      <!--<div class="row">
        <button class="btn btn-default btn-block text-left odp-btn-menu"
                [routerLink]='["/home"]' (click)="closeSidebar()">
          Home
        </button>
      </div>-->
      <!--<button class="btn btn-default btn-block text-left odp-btn-menu"
              [routerLink]='["/account/login"]' (click)="closeSidebar()">
        Log Out
      </button>-->
      <div class="row">
        <button class="btn btn-default btn-block text-left odp-btn-menu"
                id="logoutBtn"
                (click)="logout()">
          Log Out
        </button>
      </div>
      <div class="row">
        <button class="btn btn-default btn-block text-left odp-btn-menu"
                [routerLink]='["/account/edit/me"]' (click)="closeSidebar()">
          Edit My Profile
        </button>
      </div>
      <div class="row">
        <button class="btn btn-default btn-block text-left odp-btn-menu"
                [routerLink]='["/account/role/select"]'>
          Select Active Role / Project / Team
        </button>
      </div>
      <div *ngIf="menu">
        <div class="row odp-section-menu-header">
          Role: {{menu.title}}
        </div>
        <div *ngFor="let option of menu.options" class="row">
          <button class="btn btn-default btn-block text-left odp-btn-menu" [id]="option.id"
                  [hidden]="option.title === 'View/Code Abstract' ? !isUserInTeam : false"
                  [routerLink]='[option.url]' [queryParams]="option.parameters" (click)="closeSidebar()">
            {{option.title}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
